import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WindscreenWiperFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M16.04 4.88L13.04 16.78C12.72 16.76 12.36 16.76 12 16.76C9.92 16.76 7.54 17.12 5.42 17.98L2 6.9C4.98 5.3 8.36 4.54 12 4.54C13.38 4.54 14.7 4.64 16.04 4.88ZM17.86 5.28C19.3 5.66 20.7 6.2 22 6.9L18.58 17.98C17.38 17.48 16.1 17.16 14.84 16.96L17.86 5.28Z" />
    </SvgIcon>
  );
});
